import { SVGProps } from 'react';

const ArrowNext = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={19}
    height={18}
    fill="none"
    {...props}
    data-palette="ArrowNext">
    <path
      fill="#E1E1E2"
      d="M9.25 3 8.193 4.058l4.184 4.192H3.25v1.5h9.127l-4.184 4.193L9.25 15l6-6-6-6Z"
    />
  </svg>
);
export default ArrowNext;
